import {create} from 'zustand';
import { DEFAULT_PAGINATION_LIMIT } from '../../../../../../../../globalConstants';

export const useFollowUpHistoryStore = create((set)=>({
    limit: DEFAULT_PAGINATION_LIMIT,
    orderingVal: '-completed_at',
    shouldFetchData: false,
   

    setShouldFetchData: (shouldFetchData) => {
            return set((state) => ({
                ...state,
                shouldFetchData: shouldFetchData,
            }));
    },

    setLimit: (newLimit) => {
        return set((state)=>({
            ...state,
            limit: newLimit,
        }));
    },



}))